import { render } from "./EmbeddedSignupCallbackView.vue?vue&type=template&id=f652fe56&scoped=true"
import script from "./EmbeddedSignupCallbackView.vue?vue&type=script&lang=js"
export * from "./EmbeddedSignupCallbackView.vue?vue&type=script&lang=js"

import "./EmbeddedSignupCallbackView.vue?vue&type=style&index=0&id=f652fe56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f652fe56"]])

export default __exports__